<template>
  <Header />
  <article>
    <div class="kv">
      <div class="caption">
        <h1>海洋教育推廣</h1>
      </div>
    </div>
    <!-- <section class="sect1">
      <div class="ctx">
        <p>和平電力 2021 年 8 月與海巡署合作，認養位在電廠周邊也是宜蘭最南端－南澳漢本海灘的「白來分安檢所」海巡哨所，並將一樓閒置空間改裝成「漢本海洋驛站」，作為倡議「海洋保育與海洋廢棄物議題」的基地，希望藉由驛站吸引更多旅人看到漢本所在的澳花 - 宛若秘境的美麗部落。漢本海洋驛站也是海巡署全國 12 個海洋驛站當中，唯一由在地企業贊助並協助營運的場域，目前二樓以上仍有官兵駐守辦公。</p>
        <p>驛站的外觀設計由當地澳花村民透過投票共同參與，最後由當地第一位取得建築師執照的泰雅青年吳培元「會吸收故事的石頭」入選，驛站面海的牆面「Rgayung」是澳花部落的母語地名，有楓樹之意，上頭有一隻咬著鮮紅色種子的繡眼畫眉是泰雅族的占卜鳥 Ssiliq 象徵指引與守護大家，紅色種子則是隱含永續、生生不息之意。驛站入口處的牆面則畫上無限循環符號代表海巡署、台泥與地方攜手，共同為澳花生生不息的未來努力。</p>
        <div class="left">
          <p>驛站導覽員多數是在地澳花村出身，不僅陸續考取 SUP 丙級教練執照、PADl OW 初階開放水域潛水員證照也舉辦各種海上活動，希望帶動部落青年一起熟悉家鄉的海域。驛站也不定期舉辦故事導讀，由驛站的大姊姊們到澳花國小為小朋友讀繪本，透過講故事、遊戲互動的方式，認識美麗的海洋及所居住的地球。</p>
        </div>
        <div class="right">
          <img class="imgContainer1-1" src="@/assets/socialEducation/pic1_01.png" />
          <img class="imgContainer1-2" src="@/assets/socialEducation/pic1_02.png" />
        </div>
        <div class="clear"></div>
        <div class="imgContainer1-3"></div>
      </div>
    </section> -->
    <!-- <section class="sect2">
      <div class="ctx">
        <div class="sectTit">淨灘好便利</div>
        <p>2022 年驛站推出「淨灘好便利」措施，提供淨灘用具借用，尤其在後疫情時代，透過分眾服務提供深度體驗，號召旅人隨時展開愛海洋行動，想淨灘就淨灘！淨灘後還會有導覽員引導免費體驗海廢彩繪創作。</p>
        <div class="gallery">
          <div class="left">
            <div class="imgContainer2-1"></div>
          </div>
          <div class="middle">
            <div class="imgContainer2-2"></div>
          </div>
          <div class="right">
            <div class="imgContainer2-3"></div>
            <div class="imgContainer2-4"></div>
          </div>
        </div>
      </div>
    </section> -->
    <section class="sect5">
      <div class="ctx">
        <div class="desp">和平電力邀請鄰近國小教師走入海域，以不同角度重新認識家鄉海岸。由具有 SUP 立式划槳教練資格的員工親自帶領，從認識裝備、海域安全，到實際下水體驗，陪大家用最貼近海洋的方式，重新感受這片經常看見、卻不㇐定真正靠近過的海，希望讓更多人從「親近海洋」開始，引發對海洋環境的關心與珍惜，進而將這份感受帶回校園，陪伴孩子建立正向的海洋素養。</div>
        <br>
        <div class="gallery">
          <div class="imgContainer5-1"></div>
          <div class="imgContainer5-2"></div>
          <div class="imgContainer5-3"></div>
        </div>
      </div>
    </section>
    <section class="sect3">
      <div class="ctx">
        <div class="sectTit">海洋教育推廣</div>
        <p>2024 年和平電力攜手同屬台泥企業團的和平港推出「TO BE 海洋守護者」生態體驗與講座，從了解珊瑚與生物的多樣性、候鳥棲息地的保護、友善漁法與鯨豚生態等不同議題著手，也不定期進入鄰近小學，透過繪本分享，讓孩子們在聽故事的過程中，培養對大自然的興趣與好奇，將海洋教育從小紮根，爸爸媽媽也能陪同學習成長。</p>
        <div class="gallery">
          <div class="left">
            <div class="imgContainer3-1"></div>
          </div>
          <div class="right">
            <div class="imgContainer3-2"></div>
            <div class="imgContainer3-3"></div>
            <div class="imgContainer3-4"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="sect4">
      <div class="ctx">
        <div class="sectTit">TO BE 海洋守護者活動</div>
        <div class="act odd">
          <div class="sn">
              <img src="@/assets/socialEducation/pic4_01.png" />
          </div>
          <div class="desp">
            <div class="tit">和平港的房客</div>
            <div>和平生態工業港的余明善環境教育師帶著小朋友認識珊瑚對生物多樣性的重要，再觀察同屬刺絲胞動物的海葵進食行為，透過這些活動分享和平港自建港之初，因為永續環保行動而孕育出的絢爛和平大堡礁。</div>
          </div>
          <div class="thumbnail imgContainer4-1">
            <img src="@/assets/socialEducation/pic4_04.png" />
          </div>
        </div>
        <!-- Phone Hidden -->
        <div class="act even phoneHidden">
          <div class="thumbnail imgContainer4-2">
            <img src="@/assets/socialEducation/pic4_05.png" />
          </div>
          <div class="desp">
            <div class="tit">海洋鯨奇記</div>
            <div>在臺灣周遭目前紀錄有 33 種鯨豚出現，約全球種類的 1/3，在東部地區甚至出海半小時以內就有機會遇見牠們，活動中透過棲地遊戲，模擬海豚在海洋中可能受到海洋廢棄物影響而減少的樣子，讓孩子在學習互動中了解如何友善賞鯨、共同保育鯨豚。</div>
          </div>
          <div class="sn">
              <img src="@/assets/socialEducation/pic4_02.png" />
          </div>
        </div>
        <!--  -->
        <!-- Phone Visable -->
        <div class="act odd phoneVisable">
          <div class="sn">
              <img src="@/assets/socialEducation/pic4_02.png" />
          </div>
          <div class="desp">
            <div class="tit">海洋鯨奇記</div>
            <div>在臺灣周遭目前紀錄有 33 種鯨豚出現，約全球種類的 1/3，在東部地區甚至出海半小時以內就有機會遇見牠們，活動中透過棲地遊戲，模擬海豚在海洋中可能受到海洋廢棄物影響而減少的樣子，讓孩子在學習互動中了解如何友善賞鯨、共同保育鯨豚。</div>
          </div>
          <div class="thumbnail imgContainer4-2">
            <img src="@/assets/socialEducation/pic4_05.png" />
          </div>
        </div>
        <!--  -->
        <div class="act odd">
          <div class="sn">
              <img src="@/assets/socialEducation/pic4_03.png" />
          </div>
          <div class="desp">
            <div class="tit">東澳里海行動</div>
            <div>身為小漁村的東澳社區以「里海」為概念，利用在地特色推廣「環境里海遊程」，讓遊客更深入地了解漁村生活和海產文化。先藉由友善漁法 (定置漁網) 認識什麼樣的捕魚方式是相對永續，避免海洋資源枯竭，也透過釣魚遊戲教大家辨識各種魚種並實際觀察 4 月到 7 月在東澳地區盛產的飛魚，最後親自動手挑戰炒鬼頭刀魚鬆，將經濟生活與生產活動結合。</div>
          </div>
          <div class="thumbnail imgContainer4-3">
            <img src="@/assets/socialEducation/pic4_06.png" />
          </div>
        </div>
      </div>
    </section>
  </article>
  <Footer />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ImgContainerAutoResize } from '../../util/util';
import Header from '../../components/Header.vue';
import Footer from '../../components/Footer.vue';

export default defineComponent({
  name: 'SocialEducation',
  components: {
    Header,
    Footer
  },
  data() {
    return {
    }
  },
  methods: {
    setAvatar: function(avatar: string) {
      return {
        background: `url(${require(`@/assets/aboutPowerTalent/${avatar}`)})`,
        backgroundSize: "cover"
      }
    }
  },
  mounted() {
    new ImgContainerAutoResize(document.querySelector(".kv") as HTMLElement, 0.368);
    // new ImgContainerAutoResize(document.querySelector(".imgContainer1-3") as HTMLElement, 0.55);
    // new ImgContainerAutoResize(document.querySelector(".imgContainer2-1") as HTMLElement, 1.41);
    // new ImgContainerAutoResize(document.querySelector(".imgContainer2-2") as HTMLElement, 1.41);
    // new ImgContainerAutoResize(document.querySelector(".imgContainer2-3") as HTMLElement, 0.7);
    // new ImgContainerAutoResize(document.querySelector(".imgContainer2-4") as HTMLElement, 0.7);
    new ImgContainerAutoResize(document.querySelector(".imgContainer3-1") as HTMLElement, 1.7);
    new ImgContainerAutoResize(document.querySelector(".imgContainer3-2") as HTMLElement, 0.43);
    new ImgContainerAutoResize(document.querySelector(".imgContainer3-3") as HTMLElement, 1.09);
    new ImgContainerAutoResize(document.querySelector(".imgContainer3-4") as HTMLElement, 0.71);
    new ImgContainerAutoResize(document.querySelector(".imgContainer5-1") as HTMLElement, 0.8);
    new ImgContainerAutoResize(document.querySelector(".imgContainer5-2") as HTMLElement, 1.18);
    new ImgContainerAutoResize(document.querySelector(".imgContainer5-3") as HTMLElement, 0.8);
  }
});
</script>

<style>
.kv {
  height: 700px;
  position: relative;
  background: url("@/assets/socialEducation/kv.webp");
  background-position: center 48%;
  background-size: cover;
}

.kv .caption {
  width: 1200px;
  margin: 0 auto;
  padding: 25px 0;
  box-sizing: border-box;
}

.kv .caption h1 {
  margin: 0;
  display: inline-block;
  letter-spacing: 5px;
  font-weight: bold;
  font-size: 52px;
  color: #fff;
  text-shadow: 5px 5px 5px #00000066;
}

.sect {
  /* padding: 40px; */
  /* box-sizing: border-box; */
}

/* 
.sect1 p {
  line-height: 2em;
}

.sect1 .left {
  width: 48%;
  float: left;
  line-height: 2em;
}

.sect1 .right {
  width: 48%;
  float: right;
}

.sect1 .right .imgContainer1-1 {
  width: 45%;
  margin: 0 2.5%;
}

.sect1 .right .imgContainer1-2 {
  width: 45%;
  margin: 0 2.5%;
}

.sect1 .imgContainer1-3 {
  margin: 40px 0 60px;
  border-radius: 30px;
  background: url(@/assets/socialEducation/pic1_03.jpg) center;
  background-size: cover;
}

.sect2 {
  background: url(@/assets/socialEducation/sectBack2.jpg) center;
  background-size: cover;
}

.sect2 p {
  line-height: 2em;
}

.sect2 .sectTit {
  width: 300px;
  margin: auto;
  padding: 10px 20px;
  box-sizing: border-box;
  position: absolute;
  top: -35px;
  left: 0;
  right: 0;
  border-radius: 50px;
  letter-spacing: 2px;
  text-align: center;
  font-size: 36px;
  color: #E99776;
  background: #f4f3f3;
}

.sect2 .gallery {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow: hidden;
  border-radius: 30px;  
}

.sect2 .gallery .left {
  flex: 0 0 33%;

}

.sect2 .gallery .left .imgContainer2-1 {
  flex: 0 0 100%;
  background: url(@/assets/socialEducation/pic2_01.jpg) center;
  background-size: cover;
}

.sect2 .gallery .middle {
  flex: 0 0 33%;
}

.sect2 .gallery .middle .imgContainer2-2 {
  flex: 0 0 100%;
  height: 44%;
  background: url(@/assets/socialEducation/pic2_02.jpg) center;
  background-size: cover;
}

.sect2 .gallery .right {
  flex: 0 0 33%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.sect2 .gallery .right .imgContainer2-3 {
  flex: 0 0 100%;
  margin: 0 0 5px;
  background: url(@/assets/socialEducation/pic2_03.jpg) center;
  background-size: cover;
}

.sect2 .gallery .right .imgContainer2-4 {
  flex: 0 0 100%;
  background: url(@/assets/socialEducation/pic2_04.jpg) center;
  background-size: cover;
} 
*/

.sect3 {
}

.sect3 p {
  line-height: 2em;
  letter-spacing: 1px;
}

.sect3 .sectTit {
  width: 320px;
  margin: 0 auto 40px;
  padding: 3px 20px 6px;
  box-sizing: border-box;
  border-radius: 30px;
  letter-spacing: 2px;
  text-align: center;
  font-size: 36px;
  color: #fff;
  background: #0C5F99;
}

.sect3 .gallery {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow: hidden;
  border-radius: 30px;  
}

.sect3 .gallery .left {
  flex: 0 0 33.5%;

}

.sect3 .gallery .left .imgContainer3-1 {
  flex: 0 0 100%;
  background: url(@/assets/socialEducation/pic3_01.jpg) center;
  background-size: cover;
}

.sect3 .gallery .right {
  flex: 0 0 66%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.sect3 .gallery .right .imgContainer3-2 {
  flex: 0 0 100%;
  margin: 0 0 5px;
  background: url(@/assets/socialEducation/pic3_02.jpg) center;
  background-size: cover;
}

.sect3 .gallery .right .imgContainer3-3 {
  flex: 0 0 39.2%;
  background: url(@/assets/socialEducation/pic3_03.jpg) center;
  background-size: cover;
}

.sect3 .gallery .right .imgContainer3-4 {
  flex: 0 0 60%;
  background: url(@/assets/socialEducation/pic3_04.jpg) center;
  background-size: cover;
}

.sect4 .sectTit {
  margin: -40px auto 0;
  padding: 3px 20px 6px;
  box-sizing: border-box;
  letter-spacing: 2px;
  text-align: center;
  font-size: 36px;
  color: #63BFAA;
}

.sect4 .act {
  margin: 30px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  background: #fff;
}

.sect4 .act.odd {
  border-top-left-radius: 200px;
  border-bottom-left-radius: 200px;
}

.sect4 .act.even {
  border-top-right-radius: 200px;
  border-bottom-right-radius: 200px;
}

.sect4 .act.phoneVisable {
  display: none;
}

.sect4 .act .sn {
  flex: 0 0 10%;
  text-align: center;
  /* background: #ccc; */
}

.sect4 .act.odd .sn {
  text-align: right;
}

.sect4 .act.even .sn {
  text-align: left;
}

.sect4 .act .sn img {
  width: 80%;
}

.sect4 .act .desp {
  flex: 0 0 40%;
  line-height: 1.6em;
  font-size: 16px;
}

.sect4 .act .desp .tit {
  margin: 5px 0 20px;
  font-size: 24px;
  color: #63BFAA;
}

.sect4 .act .thumbnail {
  flex: 0 0 45%;
  /* background: #ccc; */
}

.sect4 .act .thumbnail img {
  width: 100%;
  vertical-align: bottom;
}

.sect5 {
  background: url(@/assets/socialEducation/sectBack2.jpg) center;
  background-size: cover;
}

.sect5 .desp {
  line-height: 2em;
  letter-spacing: 1px;
}

.sect5 .gallery {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow: hidden;
  border-radius: 30px;  
}

.sect5 .gallery .imgContainer5-1 {
  flex: 0 0 37%;
  background: url(@/assets/socialEducation/pic5_01.jpg) center;
  background-size: cover;
}

.sect5 .gallery .imgContainer5-2 {
  flex: 0 0 25%;
  background: url(@/assets/socialEducation/pic5_02.jpg) center;
  background-size: cover;
}

.sect5 .gallery .imgContainer5-3 {
  flex: 0 0 37%;
  background: url(@/assets/socialEducation/pic5_03.jpg) center;
  background-size: cover;
}

@media screen and (min-width: 1367px) and (max-width: 1600px) {
  .kv .caption h1 {
    font-size: 48px;
  }
}

@media screen and (min-width: 1201px) and (max-width: 1366px) {
  .kv .caption h1 {
    font-size: 44px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 40px;
  }

  /*
  .sect1 .left {
    width: 100%;
  }

  .sect1 .right {
    width: 100%;
  }
  
  .sect1 .right .imgContainer1-1 {
    width: 35%;
    margin: 0 7.5%;
  }

  .sect1 .right .imgContainer1-2 {
    width: 35%;
    margin: 0 7.5%;
  }
  */

  .sect4 .act.odd {
    padding: 10px 0;
    border-radius: 0;
  }

  .sect4 .act.even {
    padding: 10px 0;
    border-radius: 0;
  }
}

@media screen and (min-width: 1px) and (max-width: 767px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 24px;
    text-shadow: 3px 3px 3px #00000066;
  }

  /*
  .sect1 .left {
    width: 100%;
  }

  .sect1 .right {
    width: 100%;
  }
  */

  .sect2 .sectTit {
    width: 200px;
    top: -30px;
    font-size: 24px;
  }

  .sect2 .gallery .left {
    flex: 0 0 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .sect2 .gallery .left .imgContainer2-1 {
    width: 100%;
    height: auto;
    margin: 0 0 5px;
  }

  .sect2 .gallery .middle {
    flex: 0 0 100%;
  }

  .sect2 .gallery .middle .imgContainer2-2 {
    width: 100%;
    height: auto;
    margin: 0 0 5px;
  }

  .sect2 .gallery .right {
    flex: 0 0 100%;
  }

  .sect3 .sectTit {
    width: 220px;
    margin: 0 auto 20px;
    font-size: 24px;
  }

  .sect3 .gallery .left {
    flex: 0 0 100%;
    margin: 0 0 5px;
  }

  .sect3 .gallery .right {
    flex: 0 0 100%;
  }

  .sect3 .gallery .right .imgContainer3-2 {
    flex: 0 0 100%;
    margin: 0 0 5px;
  }

  .sect3 .gallery .right .imgContainer3-3 {
    flex: 0 0 100%;
    margin: 0 0 5px;
  }

  .sect3 .gallery .right .imgContainer3-4 {
    flex: 0 0 100%;
  }

  .sect4 .sectTit {
    font-size: 24px;
  }

  .sect4 .act {
    padding: 15px;
  }

  .sect4 .act.odd {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-radius: 10px;
  }

  .sect4 .act.even {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-radius: 10px;
  }

  .sect4 .act.phoneHidden {
    display: none;
  }

  .sect4 .act.phoneVisable {
    display: block;
  }

  .sect4 .act .sn {
    flex: 0 0 100%;
  }

  .sect4 .act .sn img {
    width: 20%;
    margin: 0 40%;
  }

  .sect4 .act .desp {
    flex: 0 0 100%;
    margin: 10px 0;
  }

  .sect4 .act .desp .tit {
    margin: 10px 0;
    text-align: center;
  }

  .sect4 .act .thumbnail {
    flex: 0 0 100%;
  }

  .sect5 .gallery .imgContainer5-1 {
    flex: 0 0 100%;
    margin: 0 0 5px;
  }

  .sect5 .gallery .imgContainer5-2 {
    flex: 0 0 100%;
    margin: 0 0 5px;
  }

  .sect5 .gallery .imgContainer5-3 {
    flex: 0 0 100%;
  }
}
</style>
